import Space from 'antd/lib/space';
import * as React from 'react';
import { AppStoreBuild, AppStoreType } from '@/types';
import {
    antGrey,
    releaseStepDetailsContainerModuleStyle,
    releaseStepModuleHeaderStyle,
    releaseStepModuleTitleStyle,
} from './styles/globalStyles';
import Text from 'antd/lib/typography/Text';
import { displayConsoleNameWithPrefix } from '../helpers/displayHelpers';
import { ReleaseStepComponentProps } from '../typescriptHelpers';
import TooltipInfoIcon from './helperComponents/TooltipInfoIcon';
import AppStoreBuildComponent from '@/components/appStoreBuilds/AppStoreBuildComponent';

interface LastUploadedAppStoreBuildModuleProps extends ReleaseStepComponentProps {
    appStoreType: AppStoreType;
    appStoreBuild?: AppStoreBuild;
}

const LastUploadedAppStoreBuildModule: React.FC<LastUploadedAppStoreBuildModuleProps> = (
    props: LastUploadedAppStoreBuildModuleProps,
) => {
    return (
        <div style={{ ...releaseStepDetailsContainerModuleStyle }}>
            <LastUploadedAppStoreBuildModuleBase {...props} />
        </div>
    );
};

export const LastUploadedAppStoreBuildModuleEmbedded: React.FC<LastUploadedAppStoreBuildModuleProps> = (
    props: LastUploadedAppStoreBuildModuleProps,
) => {
    return (
        <div style={{ paddingLeft: 24, paddingRight: 24, paddingTop: 20, paddingBottom: 20 }}>
            <LastUploadedAppStoreBuildModuleBase {...props} />
        </div>
    );
};

export const LastUploadedAppStoreBuildModuleBase: React.FC<LastUploadedAppStoreBuildModuleProps> = (
    props: LastUploadedAppStoreBuildModuleProps,
) => {
    const consoleNameWithPrefix = displayConsoleNameWithPrefix(props.appStoreType);

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ flexGrow: 1, minWidth: 0 }}>
                    <div style={{ ...releaseStepModuleHeaderStyle }}>
                        <Space>
                            <Text style={{ ...releaseStepModuleTitleStyle }}>Last successfully uploaded build</Text>
                            <TooltipInfoIcon
                                tooltipContent={`The latest build that Runway successfully uploaded to ${consoleNameWithPrefix}. Note that this does not necessarily correspond to the currently selected build in ${consoleNameWithPrefix} - if a different build was manually uploaded on ${consoleNameWithPrefix}, or a manual change was made outside of Runway, the build shown here may not match the build shown in ${consoleNameWithPrefix}.`}
                            />
                        </Space>
                    </div>
                    <Space direction="vertical" size={20} style={{ width: '100%', minWidth: 0 }}>
                        {props.appStoreBuild ?
                            <Space direction="vertical">
                                <AppStoreBuildComponent
                                    {...props.appStoreBuild}
                                    key={props.appStoreBuild.appStoreBuild.id}
                                    styleOverrides={{
                                        backgroundColor: antGrey.grey4,
                                        border: `1px solid ${antGrey.grey5}`,
                                    }}
                                />
                                <div style={{ paddingLeft: 10 }}>
                                    <Text type="warning">{`This is the last build known to be successfully uploaded. If a manual change to the selected build was made in ${consoleNameWithPrefix}, a mismatch may occur.`}</Text>
                                </div>
                            </Space>
                        :   <Text type="secondary">No uploaded builds found.</Text>}
                    </Space>
                </div>
            </div>
        </>
    );
};

export default LastUploadedAppStoreBuildModule;
